import { BUY_TYPE, IRightsType } from '@rendora/common/types/enums';
import { isUS } from '@rendora/common/utils/config';
import type { IFees } from '@rendora/common/store/rights';

/** 当前权益 → 下一档权益（升级入口用） */
export const RIGHTS_UPGRADE_NEXT: Partial<Record<IRightsType, IRightsType>> = {
  [IRightsType.TASTE]: IRightsType.PERSONAL,
  [IRightsType.PERSONAL_LITE]: IRightsType.PERSONAL,
  [IRightsType.PERSONAL]: IRightsType.ORG_STANDARD,
  [IRightsType.TEAM_TASTE]: IRightsType.TEAM_LIGHT,
  [IRightsType.TEAM_LIGHT]: IRightsType.ORG_STANDARD,
  [IRightsType.ORG_STANDARD]: IRightsType.ORG_FLAGSHIP,
  [IRightsType.ORG_FLAGSHIP]: IRightsType.ORG_CUSTOM,
  [IRightsType.ORG_CUSTOM]: IRightsType.ORG_CUSTOM,
};

/** 升级弹窗：需展示「咨询定制」的团队/企业权益类型 */
export const RIGHTS_TYPES_NEED_CONTACT: IRightsType[] = [
  IRightsType.ORG_CUSTOM,
  IRightsType.ORG_FLAGSHIP,
  IRightsType.ORG_STANDARD,
  IRightsType.TEAM_TASTE,
  IRightsType.TEAM_LIGHT,
];

/** 购买弹窗-国内：需展示「咨询定制」的权益类型 */
export const RIGHTS_TYPES_CONTACT_DOMESTIC: IRightsType[] = [
  IRightsType.ORG_FLAGSHIP,
  IRightsType.ORG_STANDARD,
  IRightsType.TEAM_TASTE,
  IRightsType.TEAM_LIGHT,
];

/** 国内：是否禁用订阅类型（连续包月/连续包年）的购买选项 */
export const DISABLE_SUBSCRIPTION_CN = true;

/** 根据区域配置过滤费用列表中的订阅选项 */
export function filterFeesBySubscription(fees: IFees[]): IFees[] {
  if (DISABLE_SUBSCRIPTION_CN && !isUS()) {
    return fees.filter(f => f.buy_type !== BUY_TYPE.SUBSCRIBE);
  }
  return fees;
}

/** 购买弹窗-海外：需展示「咨询定制」的企业权益类型（TEAM_LIGHT 单独跳转） */
export const RIGHTS_TYPES_CONTACT_US: IRightsType[] = [
  IRightsType.ORG_CUSTOM,
  IRightsType.ORG_FLAGSHIP,
  IRightsType.ORG_STANDARD,
];
